import { useParams } from 'react-router';

import useCompany from '@/modules/common/application/use-company';

export function useProjectId(): { projectId: string | null; hasProjectUrl: boolean } {
  const { projectId } = useParams();
  const { company, loading } = useCompany();

  if (projectId) {
    return { projectId, hasProjectUrl: true };
  }

  if (loading || !company) {
    return { projectId: null, hasProjectUrl: false };
  }

  if (company?.defaultProjectId) {
    return { projectId: company.defaultProjectId, hasProjectUrl: false };
  }

  throw new Error('No global project found for this company');
}
